module.exports = __webpack_public_path__ + "static/FL1-37ce1155d9f7716931779a6e7efe9e90.jpg";